var _rect, _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup2029(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_725_1602)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    rx: 24,
    fill: "url(#paint0_linear_725_1602)"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    rx: 24,
    fill: "url(#paint1_linear_725_1602)",
    fillOpacity: 0.2,
    style: {
      mixBlendMode: "soft-light"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M226.726 118.869C225.948 113.337 229.817 108.202 235.35 107.424C240.882 106.647 246.017 110.516 246.794 116.048L247.648 122.122C247.955 124.309 246.431 126.332 244.244 126.64L232.097 128.347C229.909 128.654 227.887 127.13 227.579 124.942L226.726 118.869ZM222.856 139.878C222.597 138.031 223.884 136.323 225.731 136.063L252.49 132.302L396.24 112.1C397.416 111.934 398.604 112.3 399.484 113.097L431.459 142.084C432.889 143.38 433.189 145.514 432.171 147.155L409.425 183.832C408.799 184.841 407.758 185.52 406.582 185.685L262.831 205.888L236.073 209.649C234.226 209.908 232.518 208.621 232.258 206.774L222.856 139.878ZM240.915 219.829C240.607 217.642 242.131 215.619 244.319 215.312L256.466 213.604C258.653 213.297 260.676 214.821 260.983 217.009L262.691 229.156C262.998 231.343 261.474 233.366 259.286 233.673L247.139 235.38C244.952 235.688 242.929 234.164 242.622 231.976L240.915 219.829ZM72.0827 306.91C70.6522 305.613 70.3523 303.48 71.37 301.839L94.1167 265.161C94.7424 264.153 95.7838 263.474 96.9594 263.309L240.774 243.097L267.532 239.336C269.379 239.076 271.087 240.364 271.347 242.211L280.749 309.107C281.008 310.954 279.721 312.662 277.874 312.922L251.116 316.682L107.298 336.895C106.122 337.06 104.934 336.694 104.055 335.897L72.0827 306.91ZM285.819 393.72C286.126 395.908 284.602 397.93 282.414 398.238L270.267 399.945C268.08 400.252 266.057 398.728 265.75 396.54L255.957 326.863C255.65 324.675 257.174 322.653 259.362 322.345L271.508 320.638C273.696 320.331 275.719 321.855 276.026 324.043L285.819 393.72Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dii_725_1602)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M222.857 139.878C222.598 138.031 223.885 136.323 225.732 136.063L252.491 132.302L394.386 112.36C396.737 112.03 399.114 112.761 400.873 114.355L428.99 139.845C431.851 142.439 432.451 146.706 430.415 149.988L410.413 182.24C409.162 184.258 407.079 185.616 404.728 185.946L262.832 205.888L236.074 209.649C234.227 209.908 232.519 208.621 232.259 206.774L222.857 139.878ZM74.5532 309.149C71.6922 306.555 71.0925 302.288 73.1279 299.006L93.1304 266.754C94.3817 264.736 96.4646 263.378 98.8157 263.048L240.775 243.097L267.533 239.336C269.38 239.077 271.088 240.364 271.348 242.211L280.75 309.107C281.009 310.954 279.722 312.662 277.875 312.922L251.117 316.683L109.154 336.634C106.803 336.964 104.427 336.233 102.668 334.639L74.5532 309.149Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_725_1602",
    x: -2.0348,
    y: -2.0348,
    width: 516.07,
    height: 516.07,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.0348,
    dy: 2.0348
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.0174
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_725_1602"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2.0348,
    dy: -2.0348
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.0174
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_725_1602",
    result: "effect2_innerShadow_725_1602"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dii_725_1602",
    x: 22.6841,
    y: 89.8996,
    width: 458.175,
    height: 322.914,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 26.8594
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 24.6211
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_725_1602"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_725_1602",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -17.9063
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.1914
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.29 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_725_1602"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -6.71485
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.47656
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.75 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_725_1602",
    result: "effect3_innerShadow_725_1602"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_725_1602",
    x1: 256,
    y1: 0,
    x2: 256,
    y2: 512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#017ADB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007DE1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_725_1602",
    x1: 256,
    y1: 0,
    x2: 256,
    y2: 512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup2029);
export default __webpack_public_path__ + "static/media/Group 2029.4d9a41183d83869579a67511f8dea475.svg";
export { ForwardRef as ReactComponent };